import * as React from 'react';
import {
    Route,
    Switch,
    RouteComponentProps,
} from "react-router-dom";
import UserExportPage from './UserExportPage';

type TParams = { id: string, url: string }

function UserExport({ match }: RouteComponentProps<TParams>) {
    return (
        <Switch>
            <Route exact path={`${match.url}`} component={UserExportPage} />
        </Switch>
    );
}

export default UserExport;